import React, { useMemo } from 'react'
import ExternalLink from '@groovehq/internal-design-system/lib/assets/icons/ExternalLink'
import { shopifyMoneyString } from 'util/currency'

const OrderLineItem = ({ lineItem, integration }) => {
  const storeDomain = integration.storeDomain
  const { product } = lineItem
  let url
  if (product) {
    const productId = product.id.replace(/[^\d]*/, '')
    url = `https://${storeDomain}.myshopify.com/admin/products/${productId}`
  }
  const discountedShopMoney = lineItem.discountedUnitPriceSet.shopMoney
  const totalShopMoney = lineItem.discountedTotalSet.shopMoney
  const itemText = useMemo(
    () => {
      return (
        <>
          {shopifyMoneyString(discountedShopMoney)}&nbsp;&times;&nbsp;
          {lineItem.currentQuantity}
        </>
      )
    },
    [discountedShopMoney, lineItem]
  )

  const total = discountedShopMoney.amount * lineItem.currentQuantity

  return (
    <tbody className="shopifyV2-order-table-lineItem">
      <tr>
        <th colSpan="2">
          {url && (
            <a href={url} target="_blank" rel="noopener noreferrer">
              {lineItem.name}
              <ExternalLink className="shopifyV2-externalLink-icon" />
            </a>
          )}
          {!url && lineItem.name}
        </th>
      </tr>
      <tr className="shopifyV2-currency">
        <th scope="row" className="shopifyV2-order-table-itemText">
          {itemText}
        </th>
        <td className="grui text-right">
          {shopifyMoneyString({
            amount: total,
            currencyCode: totalShopMoney.currencyCode,
          })}
        </td>
      </tr>
    </tbody>
  )
}

export default OrderLineItem
